import { Link, Outlet } from "react-router-dom";
import { FileOrderNotice } from "../components/layout/FileOrderNotice";
import { DateOrderingToastListener } from "../components/ui/DateOrderingToastListener";
import { Toaster } from "../components/ui/Toaster";
import { APP_VERSION, BUILD_COMMIT_SHORT } from "../lib/build-info";
import { useUiStore } from "../stores/ui-store";

export function RootLayout() {
  const reset = useUiStore((state) => state.reset);
  return (
    <>
      <header className="flex items-center justify-between border-b bg-white px-6 py-3">
        <Link to="/" onClick={reset} className="text-sm font-semibold text-slate-900">
          JSON Data Drift Analyzer
        </Link>
        <nav className="flex items-center gap-1">
          <Link to="/runs" className="rounded-sm px-3 py-1 text-sm text-sky-700 hover:bg-slate-100" data-testid="runs-link">
            Runs
          </Link>
          <Link to="/profiles" className="rounded-sm px-3 py-1 text-sm text-sky-700 hover:bg-slate-100" data-testid="profiles-link">
            Profiles
          </Link>
          <Link to="/" onClick={reset} className="rounded-sm px-3 py-1 text-sm text-sky-700 hover:bg-slate-100" data-testid="new-analysis-link">
            New analysis
          </Link>
        </nav>
      </header>
      <FileOrderNotice />
      <Outlet />
      {/* The identifiers a "wrong numbers" report can cite. */}
      <footer className="border-t px-6 py-2 text-xs text-slate-500">
        <span data-testid="app-version">v{APP_VERSION}</span> · Build{" "}
        <code data-testid="build-commit">{BUILD_COMMIT_SHORT}</code>
      </footer>
      <DateOrderingToastListener />
      <Toaster />
    </>
  );
}
